"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var const_1 = require("./util/const");
var vf_mesh_factory_1 = require("./util/vf-mesh-factory");
var logger_1 = require("./util/logger");
var vector_functions_1 = require("./util/vector-functions");
var vf_config_manager_1 = require("./util/vf-config-manager");
var vf_material_factory_1 = require("./util/vf-material-factory");
var colors_1 = require("./util/colors");
var VFTrigger = (function () {
    function VFTrigger(name, parentNode, scene, triggerMeta, properties) {
        var e_1, _a;
        var _this = this;
        this.name = name;
        this.parentNode = parentNode;
        this.scene = scene;
        this.triggerMeta = triggerMeta;
        this.properties = properties;
        this._visibility = true;
        var needsButton = true;
        var hasMesh = false;
        this._identifier = properties["identifier"];
        if (this.parentNode instanceof babylonjs_1.AbstractMesh) {
            hasMesh = true;
            var originalMesh = this.parentNode;
            if (originalMesh.isAnInstance) {
                originalMesh = scene.createObjectForInstance(originalMesh, null, false);
                originalMesh.material = scene.getMaterialForObject(originalMesh);
            }
            this.mesh = originalMesh;
            this.hasButtonMesh = false;
            this.mesh.actionManager = new babylonjs_1.ActionManager(scene);
            this.mesh.isPickable = true;
        }
        var children = this.parentNode.getChildren();
        if (children.length > 0) {
            try {
                for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                    var child = children_1_1.value;
                    if (child instanceof babylonjs_1.AbstractMesh) {
                        child.isPickable = false;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            hasMesh = true;
        }
        if (this.triggerMeta.enableScreenButton === true) {
            needsButton = true;
        }
        else {
            if (this.scene.model.formatVersion > 1000) {
                needsButton = false;
                if (!hasMesh) {
                    var path = scene.getPathForNode(this.parentNode);
                    logger_1.default.warn("trigger is invisible (no mesh and no UI button): " + path);
                }
            }
            else {
                needsButton = true;
            }
        }
        if (needsButton) {
            this.buttonMesh = undefined;
            this.getMaterial().then(function (material) {
                _this.buttonMesh = vf_mesh_factory_1.default.CreateTriggerMesh(name, _this, scene, material);
                _this.hasButtonMesh = true;
                _this.animationSurrogate = _this.buttonMesh.parent;
                _this.animationSurrogate.position.addInPlace(_this.getPositionOffset());
                var triggerScale = scene.isAuraScene ? 3 : 1;
                if (_this.properties) {
                    if (_this.properties["button_size"]) {
                        triggerScale *= _this.properties["button_size"];
                    }
                }
                triggerScale = const_1.default.TRIGGER_MESH_SCALE * triggerScale;
                if (!_this.scene.playerConfig.enableEditor) {
                    triggerScale *= const_1.default.TRIGGER_BUTTON_SCALE_VIEWER_FACTOR;
                }
                _this.setScale(triggerScale);
                if (!hasMesh) {
                    _this.parentNode.setEnabled(false);
                }
                _this.buttonMesh.actionManager = new babylonjs_1.ActionManager(scene);
                _this.buttonMesh.isPickable = true;
                _this.setAnimationListeners();
                _this.setClickListener();
                _this.setHoverListener();
                if (_this._triggerLoadedCallback != null) {
                    _this._triggerLoadedCallback(_this);
                }
            });
        }
        else {
            this.setClickListener();
            this.setHoverListener();
        }
    }
    Object.defineProperty(VFTrigger.prototype, "node", {
        get: function () {
            return this.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    VFTrigger.prototype.updatePosition = function () {
        if (this.animationSurrogate) {
            var oldPosition = this.buttonNode.getAbsolutePosition().clone();
            this.buttonNode.setAbsolutePosition(this.parentNode.getAbsolutePosition().multiply(vector_functions_1.makeAbs(this.scene.model.getRoot().scaling)));
            this.animationSurrogate.position.addInPlace(this.getPositionOffset());
            var newPosition = this.buttonNode.getAbsolutePosition();
            if (this._triggerMovedCallback && !oldPosition.equals(newPosition)) {
                this._triggerMovedCallback(this);
            }
        }
    };
    VFTrigger.prototype.updateRotation = function (rotationDegrees) {
        var oldLookDirection = this.triggerMeta.lookDirection;
        this.pathNode.reIntegrateRotationIntoRotationQuaternion = true;
        if (this.pathNode.rotationQuaternion) {
            this.pathNode.rotation = this.pathNode.rotationQuaternion.toEulerAngles();
        }
        if (rotationDegrees) {
            this.pathNode.rotation.y = babylonjs_1.Tools.ToRadians(this.triggerMeta.lookDirection);
        }
        this.triggerMeta.lookDirection = babylonjs_1.Tools.ToDegrees(this.pathNode.rotation.y);
        if (this._triggerMovedCallback && oldLookDirection !== this.triggerMeta.lookDirection) {
            this._triggerMovedCallback(this);
        }
    };
    Object.defineProperty(VFTrigger.prototype, "resolvedMesh", {
        get: function () {
            if (this.mesh != null) {
                return this.mesh;
            }
            return this.buttonMesh;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFTrigger.prototype, "pathNode", {
        get: function () {
            if (this.parentNode.parent == null) {
                return this.mesh;
            }
            return this.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    VFTrigger.prototype.destroy = function () {
        if (this.buttonMesh) {
            this.buttonMesh.dispose();
        }
        if (this.mesh) {
            this.mesh.dispose();
        }
        if (this.animationSurrogate) {
            this.animationSurrogate.dispose();
        }
    };
    VFTrigger.prototype.setScale = function (scale) {
        if (this.hasButtonMesh) {
            var scaleFactor = scale / const_1.default.TRIGGER_MESH_SCALE;
            var newScale = this.parentNode.scaling.scale(scaleFactor);
            logger_1.default.debug("Scaling trigger '" + this.name + "' to " + newScale + ".");
            this.buttonMesh.scaling = newScale;
        }
        else {
            logger_1.default.error('Trigger has no button mesh.');
        }
    };
    VFTrigger.prototype.getMaxScale = function () {
        var minScale = const_1.default.TRIGGER_BUTTON_SCALE_FACTOR;
        var array = this.scene.model.size.asArray();
        var max = Math.max.apply(Math, __spread(array));
        if (max < minScale * minScale) {
            return minScale;
        }
        else {
            max = max / minScale;
            return Math.floor(max / 10) * 10;
        }
    };
    VFTrigger.prototype.onClickInternal = function () {
        this.scene.onClickTrigger(this);
        if (vf_config_manager_1.default.GetConfig().enableEditor) {
            return;
        }
        this.onClick(false);
    };
    VFTrigger.prototype.onHover = function () {
        this.scene.triggerHovered(this);
        if (this.mesh) {
            this.mesh.outlineColor = babylonjs_1.Color3.White();
            this.mesh.outlineWidth = 0.005;
            this.mesh.renderOutline = true;
            this.mesh.overlayColor = babylonjs_1.Color3.White();
            this.mesh.overlayAlpha = 0.25;
            this.mesh.renderOverlay = true;
        }
    };
    VFTrigger.prototype.onUnhover = function () {
        this.scene.triggerUnhovered(this);
        if (this.mesh) {
            this.mesh.renderOutline = false;
            this.mesh.renderOverlay = false;
        }
    };
    VFTrigger.prototype.dispose = function () {
        if (this.mesh) {
            if (this.mesh.actionManager) {
                this.mesh.actionManager.dispose();
            }
            this.mesh.dispose();
        }
        if (this.buttonMesh && this.buttonMesh !== this.mesh) {
            if (this.buttonMesh.actionManager) {
                this.buttonMesh.actionManager.dispose();
            }
            this.buttonMesh.dispose();
        }
    };
    VFTrigger.prototype.getCurrentButtonTexture = function () {
        if (!this.hasButtonMesh) {
            return null;
        }
        var oldMaterial = this.buttonMesh.material;
        var textures = oldMaterial.getActiveTextures();
        if (textures.length > 0) {
            return textures[0];
        }
        else {
            return null;
        }
    };
    VFTrigger.prototype.getCurrentButtonMaterialIdentifier = function () {
        if (this.hasButtonMesh) {
            return this.buttonMesh.material.name;
        }
        else {
            return null;
        }
    };
    VFTrigger.prototype.setMaterial = function (identifier, color, texture, textureUrl) {
        if (this.hasButtonMesh) {
            if (texture == null && textureUrl == null) {
                logger_1.default.error("setMaterial needs either texture or textureUrl!");
                return;
            }
            if (texture == null) {
                logger_1.default.debug("setMaterial uses textureUrl property.");
                texture = new babylonjs_1.Texture(textureUrl, this.scene);
            }
            var material = vf_material_factory_1.default.GetMaterialWithColorAndTexture(this.scene, identifier, texture, color);
            logger_1.default.debug("Set material with name '" + material.name + "' to trigger '" + this.name + "'.");
            this.buttonMesh.material = material;
        }
        else {
            logger_1.default.error('Trigger has no button mesh.');
        }
    };
    VFTrigger.prototype.getPositionOffset = function () {
        return babylonjs_1.Vector3.Zero();
    };
    Object.defineProperty(VFTrigger.prototype, "position", {
        get: function () {
            return this.node.position;
        },
        set: function (value) {
            this.node.position = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFTrigger.prototype, "rotation", {
        get: function () {
            return this.triggerMeta.lookDirection;
        },
        set: function (value) {
            this.triggerMeta.lookDirection = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFTrigger.prototype, "customColor", {
        get: function () {
            var customColor = null;
            if (this.properties && this.properties["custom_color"]) {
                customColor = this.properties["custom_color"];
                customColor = colors_1.parseColorRGBAObjectToVFColor(customColor);
            }
            return customColor;
        },
        enumerable: true,
        configurable: true
    });
    VFTrigger.prototype.setClickListener = function () {
        var _this = this;
        if (this.mesh) {
            this.mesh.actionManager.registerAction(new babylonjs_1.ExecuteCodeAction(babylonjs_1.ActionManager.OnPickTrigger, function () {
                _this.onClickInternal();
            }));
        }
        if (this.buttonMesh) {
            this.buttonMesh.actionManager.registerAction(new babylonjs_1.ExecuteCodeAction(babylonjs_1.ActionManager.OnPickTrigger, function () {
                _this.onClickInternal();
            }));
        }
    };
    VFTrigger.prototype.setHoverListener = function () {
        var _this = this;
        if (this.mesh) {
            this.mesh.actionManager.registerAction(new babylonjs_1.ExecuteCodeAction(babylonjs_1.ActionManager.OnPointerOverTrigger, function () {
                _this.onHover();
            }));
            this.mesh.actionManager.registerAction(new babylonjs_1.ExecuteCodeAction(babylonjs_1.ActionManager.OnPointerOutTrigger, function () {
                _this.onUnhover();
            }));
        }
        if (this.buttonMesh) {
            this.buttonMesh.actionManager.registerAction(new babylonjs_1.ExecuteCodeAction(babylonjs_1.ActionManager.OnPointerOverTrigger, function () {
                _this.onHover();
            }));
            this.buttonMesh.actionManager.registerAction(new babylonjs_1.ExecuteCodeAction(babylonjs_1.ActionManager.OnPointerOutTrigger, function () {
                _this.onUnhover();
            }));
        }
    };
    Object.defineProperty(VFTrigger.prototype, "triggerType", {
        get: function () {
            return this.triggerMeta.type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFTrigger.prototype, "identifier", {
        get: function () {
            if (!this._identifier) {
                this._identifier = "_" + Math.random().toString(36).substr(2, 9);
            }
            return this._identifier;
        },
        enumerable: true,
        configurable: true
    });
    VFTrigger.prototype.setActive = function (state) {
        if (this.hasButtonMesh) {
            if (this.mesh) {
                this.mesh.setEnabled(state);
            }
            if (this.buttonMesh && this.buttonMesh !== this.mesh) {
                this.buttonMesh.setEnabled(state);
            }
            this.node.setEnabled(state);
        }
    };
    VFTrigger.prototype.setVisibility = function (state) {
        this._visibility = state;
    };
    VFTrigger.prototype.getVisibility = function () {
        return this._visibility;
    };
    VFTrigger.prototype.setAnimationListeners = function () {
        this.buttonMesh.actionManager.registerAction(new babylonjs_1.InterpolateValueAction(babylonjs_1.ActionManager.OnPickDownTrigger, this.animationSurrogate, "scaling", this.animationSurrogate.scaling.scale(1 / const_1.default.TRIGGER_ACTION_SCALE_FACTOR), const_1.default.TRIGGER_ACTION_ANIMATION_DURATION, null, true));
        this.buttonMesh.actionManager.registerAction(new babylonjs_1.InterpolateValueAction(babylonjs_1.ActionManager.OnPickUpTrigger, this.animationSurrogate, "scaling", this.animationSurrogate.scaling.scale(const_1.default.TRIGGER_ACTION_SCALE_FACTOR), const_1.default.TRIGGER_ACTION_ANIMATION_DURATION, null, true));
        this.buttonMesh.actionManager.registerAction(new babylonjs_1.InterpolateValueAction(babylonjs_1.ActionManager.OnPointerOverTrigger, this.animationSurrogate, "scaling", this.animationSurrogate.scaling.scale(const_1.default.TRIGGER_ACTION_SCALE_FACTOR), const_1.default.TRIGGER_ACTION_ANIMATION_DURATION, null, true));
        this.buttonMesh.actionManager.registerAction(new babylonjs_1.InterpolateValueAction(babylonjs_1.ActionManager.OnPointerOutTrigger, this.animationSurrogate, "scaling", this.animationSurrogate.scaling.scale(1 / const_1.default.TRIGGER_ACTION_SCALE_FACTOR), const_1.default.TRIGGER_ACTION_ANIMATION_DURATION, null, true));
    };
    VFTrigger.prototype.registerTriggerMovedCallback = function (callback) {
        this._triggerMovedCallback = callback;
    };
    VFTrigger.prototype.registerTriggerLoadedCallback = function (callback) {
        this._triggerLoadedCallback = callback;
    };
    return VFTrigger;
}());
exports.default = VFTrigger;
